import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceDeadlineStatusEnum } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { constantCase } from 'change-case';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Pipe({ name: 'translateMaintenanceDeadlineStatus' })
export class TranslateDeadlineStatusPipe implements PipeTransform {
  constructor(
    private readonly translateService: TranslateService,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform (type: MaintenanceDeadlineStatusEnum): string {
    if (!type) {
      return null;
    }

    return this.translateService.instant(`MAINTENANCE_DEADLINE_STATUS.${constantCase(type)}`);
  }
}
